module.exports = __webpack_public_path__ + "static/e-learning-31d029737c964908fb1024efa05f6dd9.png";